import { connect } from 'react-redux';
import { redux } from '../api';

import UploadForm from './UploadForm.js';

const { setCurrentSearchInfo, setUserInfo, setApplicationInfo } = redux.actions;
const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  return {
    viewportData: state.viewports.viewportSpecificData,
    context: state.ui.heatmapContext,
    server: activeServer,
    userInfo: state.api.user.info,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setCurrentSearchInfoData: data => dispatch(setCurrentSearchInfo(data)),
    onUserInfoUpdated: user => dispatch(setUserInfo(user)),
    setApplicationData: data => dispatch(setApplicationInfo(data)),
  };
};

const ConnectedUploadForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadForm);

export default ConnectedUploadForm;
